import Storage from '../lib/storage';
import UUID from '../lib/uuid';
import { checkIsSuperBrand } from '@/lib/tools';

const Cookies = new Storage('cookie');

/**
 * 数据埋点相关信息
 * @returns {String}
 */
function getSrxUserInfo() {
    return Cookies.getItem('srxUserInfo') || `distinctId=${UUID()}`;
}

function getCookiesVal(key = '') {
    return Cookies.getItem(key);
}

/**
 * 获取请求头相关参数
 * @returns {Object} 请求头header对象
 * @param {Record<string, string>} data
 */

function getSuperBrandApi() {
    const env = process.env.VUE_APP_MODE;
    let suffix = '';
    switch (env) {
        case 'local':
            suffix = '-dev';
            break;
        case 'dev':
            suffix = '-dev';
            break;
        case 'qa':
            suffix = '-qa';
            break;
        default:
            break;
    }
    return getApiPrefixV2(`school${suffix}.3ren.cn`);
}

function getRequestHeaders(data) {
    let url = new URL(location.href);
    let searchParams = new URLSearchParams(url.search);
    let currentAccessToken = 'X-DT-accessToken';
    if (searchParams.has('type') && searchParams.get('type') == 'share' && checkIsSuperBrand()) {
        if (Cookies.getItem('X-DT-accessToken') !== '') {
            currentAccessToken = 'X-DT-accessToken';
        } else {
            currentAccessToken = 'super-wand-X-DT-accessToken'
        }
    } else {
        currentAccessToken = checkIsSuperBrand() ? 'super-wand-X-DT-accessToken' : 'X-DT-accessToken';
    }
   
    const accessToken = getCookiesVal(currentAccessToken);
    const clientId = checkIsSuperBrand() ? 'sanren-wand-pc' : 'sanren-teacher-pc';
    const headers = Object.assign(
        {
            'Content-Type': 'application/json',
            Authorization: 'Basic c2FucmVuLXdhbmQtcGM6UjNOaHR2MUkyVVpsR1RmcTBv',
            'X-DT-clientId': clientId,
            'X-DT-accessToken': accessToken || '',
            'X-DT-Passport': Cookies.getItem('passport') || '',
            srxUserInfo: getSrxUserInfo(),
        },
        data,
    );
    return headers;
}

/**
 * 根据url解析domain，或是获取当前浏览器url的domain
 * @param {string=} url 解析url的domain
 * @returns
 */
function getApiPrefixV2(url = '') {
    let domain = url || document.domain;
    let reg =
        /(?:www|www-dev\.)?([\w\-]*)*?(?:\.)?([\w\-]*)*?(?:\.)?([\w\-][\w\-]*?\.[\w\-\z]+)([\/|\?].*)?$/i;
    let arr = domain.match(reg);
    let str = '';

    if (arr && arr.length > 0) {
        if (arr[1]) {
            str = `${arr[1]}-api.${arr[2]}`;
        } else if (arr[2]) {
            if (/(-dev|-qa|-test)/.test(arr[2])) {
                str = arr[2].replace(/(-dev|-qa|-test)/, '-api$1').replace(/^-/, '');
            } else {
                str = `${arr[2]}-api`;
            }
        } else {
            str = 'api';
        }
        str += `.${arr[3]}`;
    }
    if (str) {
        return `${location.protocol}//${str}`;
    } else {
        throw new Error(`Get api host error: ${domain}`);
    }
}
export { getRequestHeaders, getApiPrefixV2, getSuperBrandApi };
